import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/features/cool-svgrepo-com.svg")